export default function statusDirective(DataService) {
	"ngInject";

	return {
		restrict: "E",
		replace: true,
		templateUrl: "./components/status/status-template.html",
		scope: {
			org: "=",
			compress: "<?",
			ignore: "@?"
		},
		bindToController: true,
		controllerAs: "vm",
		controller: function () {
			"ngInject";

			const vm = this;

			const statuses = [
				{id: "overlaps", icon: "warning", check: DataService.isStatusFlagged},
				{id: "referrals", icon: "dont", check: DataService.isNonReferrals},
				{id: "sync", icon: "history", check: DataService.isBoundaryPending},
			];

			vm.$onInit = () => {
				vm.ignores = (vm.ignore || "").split(",");
			};

			vm.getCurrentStatus = () => {
				let currentStatus = [];
				if (vm.org) {
					statuses.forEach((status) => {
						if (vm.ignores.indexOf(status.id) === -1 && status.check(vm.org)) {
							currentStatus.push(status.id);
						}
					});
				}
				return currentStatus;
			};

			vm.getStatusIcon = (statusId) => (
				vm.getStatus(statusId).icon
			);

			vm.getStatus = (statusId) => (
				statuses.filter((status) => (status.id === statusId))[0]
			);

		}
	};
}
